"use client";
import {useEffect} from "react";
import {Button} from "@/app/_components";
import GameTrack from "@/Core/GameTrack";
import styles from "./Step3_4_5.module.css";

type Step3Props = {
    target?: () => HTMLElement | null;
    currentStep?: number;
    currIndex: number;
    onNext?: (idx: number) => void;
}

const buttonStyle: React.CSSProperties = {
    color: "#fff",
    width: "3.7rem",
    height: "1.1rem",
    fontWeight: 900,
    fontSize: ".5rem"
}

const Step3: React.FC<Step3Props> = props => {
    const { target, currentStep, currIndex, onNext } = props;

    const _targetStyle = target?.()?.getBoundingClientRect();
    if (!_targetStyle) return;

    const { x, y, width, height } = _targetStyle;
    const wrapperStyle: React.CSSProperties = {
        position: 'absolute',
        width: width,
        height: '1.95rem',
        bottom: 0,
        left: x,
    }

    useEffect(() => {
        return () => {
        };
    }, [])

    const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        // e.stopPropagation();
        // onNext && onNext(currIndex + 1)
    }

    return (
        <>
            {(currentStep === currIndex) && <div style={wrapperStyle}>
                <div className={styles.step3}>
                    {<img src="/img/guide/redeem.webp" style={{width: width > 129 ? 129 : width}} alt=""/>}
                    <div className={styles.arrow}></div>
                    <div className={`${styles.popover} ${styles.popover_step3}`}>
                        In the REDEEM section you can redeem your winnings for&nbsp;
                        <span style={{color: '#DB496F', fontWeight: 900}}>REAL CASH.</span>
                        <div className={styles.tips}>1SC = 1USD</div>
                        <div className={`${styles.button} ${styles.button_Step3}`}>
                            <Button color="#0090FF" style={buttonStyle} onClick={handleClick}>Awesome</Button>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    )
}

export default Step3;